export const formatPhoneNumber = (value: string) => {
    return value === '44' ? '' : value.startsWith('440') ? `44${value.substr(3)}` : value;
};
